import React, { useState, useEffect } from "react";
import axios from "axios";
import { json, useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function CustomerInput() {
  const navigate = useNavigate();
  let [token, setToken] = useState("");
  const [internalData, setInternalData] = useState(null);
  const [error, setError] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [picName, setPicName] = useState("");
  const [email, setEmail] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [inputCompanyList, setInputCompanyList] = useState('');
  
  const resource = 'input-customer';

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();

    

    loadCompanyList();
  }, []);

  const loadCompanyList = async () => {
    const result = await axios.get("https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/company/find-all");
    const data = result.data.body;  
    setCompanyList(data);
  };

  useEffect(() => {
    // Retrieve the token from local storage
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    // Fetch internal data using the token
    const fetchInternalData = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        if (!response.ok) {
          setError(data.message || "Failed to fetch internal data");
          throw new Error(data.message || "Failed to fetch internal data");
        }

        setInternalData(data[0]);
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    fetchInternalData();
  }, []);

  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0];
    setRegisterDate(currentDate);
  }, []);

  function getDateTimeInUserTimeZone(registerDate) {
    const userTimeZone = moment.tz.guess();
    // Get the current time in the user's local time zone
    const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");
    // Combine the selected date with the current time
    const dateTimeInUserTimeZone = moment
      .tz(`${registerDate}T${currentTime}`, userTimeZone)
      .format("YYYY-MM-DDTHH:mm:ss");
    return dateTimeInUserTimeZone;
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    
      let dateTimeInUserTimeZone = getDateTimeInUserTimeZone(registerDate);
      const formData = {
        internal_email: internalData.xcp_internal_email,
        register_date: dateTimeInUserTimeZone,
        company_id: inputCompanyList,
        pic_name: picName,
        email: email
      };

      try {
        const response = await fetch(
          "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/customer/input-customer",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        const data = await response.json();
        const responseBody = JSON.parse(data.body);
        if (!response.ok) {
          setError(data.message || "Failed to submit form");
          throw new Error(data.message || "Failed to submit form");
        }

        const { message } = responseBody;
        if (message == "success") {
          setOpenConfirm(false)
          setOpenInputSuccess(true)
        } else {
          setOpenConfirm(false)
          setOpenInputFail(true)
        }
      } catch (error) {
        console.error("Submission Error:", error.message);
        setError("Submission Error: " + error.message);
      }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenInputFail(false)
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    setOpenConfirm(true);
  };

  function inputSuccess(){
    navigate("/customer-list")
  }

  const handleCompanyListChange = (event) => {
    setInputCompanyList(event.target.value);
  };

  return (
    <div className="container-order-input">
      <Dialog open={openConfirm}>
          <DialogTitle>{"Are you sure you want to input this customer?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will input this customer.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleSubmit} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
        </Dialog> 
        <Dialog open={openInputSuccess}>
          <DialogTitle>{"Customer Form submitted successfully"}</DialogTitle>
          <DialogActions>
            <Button onClick={inputSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openInputFail}>
        <DialogTitle>{"Customer Form submitted failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <h1>Cross Connect Customer Form</h1>
      <form onSubmit={handleConfirmation}>
        <div className="order-information-order-input">
          <div className="title-order-input">
            <h6>Fullfill the customer form as follows.</h6>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="textbox-gray">
              <label htmlFor="registerDate">Register Date</label>
              <input
                type="date"
                id="registerDate"
                value={registerDate}
                onChange={(e) => setRegisterDate(e.target.value)}
                required
                disabled
              />
            </div>
          
          {/* <div className="value-status"> */}
              <div className="textbox">
                  <label htmlFor="comboBox">Company Name</label>
                  <select id="comboBox" name="options" value={inputCompanyList} onChange={handleCompanyListChange}>
                      <option hidden>Select Company</option>
                      {companyList.map((item) => (
                      <option key={item.company_id} value={item.company_id}>
                          {item.company_name}
                      </option>
                      ))}
                  </select>                         
              </div>             
          {/* </div> */}

            <div className="textbox">
              <label htmlFor="picName">PIC Name</label>
              <input
                type="text"
                placeholder="PIC Name"
                onChange={(e) => setPicName(e.target.value)}
                required
              />
            </div>
            <div className="textbox">
              <label htmlFor="contactEmail">Email</label>
              <input
                type="email"
                placeholder="xxx@xxx.com"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
        </div>
        <input
          type="submit"
          className="btn-submit-order-input"
          value="Submit"
        />
      </form>
    </div>
  );
}

export default CustomerInput;
